module.exports = __webpack_public_path__ + "img/1.a6fc07fb.jpg";